import modules from './modules';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
});

// Automatically run the `init` action for every module,
// if one exists.
Object.keys(modules).forEach((moduleName) => {
  if (modules[moduleName].actions && modules[moduleName].actions.init) {
    store.dispatch(`${moduleName}/init`);
  }
});


// Events
const debouncedUpdate = _.debounce(() => {
  store.commit('application/SET_APP_WIDTH', window.innerWidth);
}, 200);

window.addEventListener('resize', debouncedUpdate);

export default store;
